import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { actions } from "../store/index";

import Header from "../components/Header/header";
import Billboards from "../components/billboards/Billboards";
import Road from "../components/road";
import Panel from "../components/panel";

import "./basic-layut.css";

import { Layout, Menu, Icon, Modal, Dropdown, Spin } from "antd";

const { Sider, Content } = Layout;

const mapStateToProps = state => ({
  title: state.mainState.title,
  infoToggle: state.mainState.infoToggle,
  state: state.Billboards.data.state,
  ends: state.Billboards.data.ends,
  price: state.Billboards.data.rentPrice,
  renter: state.Billboards.data.renter,
  bid: state.Billboards.data.bid,
  isLoading: state.Billboards.isLoading,
  currentUserKey: state.mainState.currentUserKey,
});

// @connect(mapStateToProps)
class BasicLayout extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    infoToggle: PropTypes.bool.isRequired,
    state: PropTypes.string,
    ends: PropTypes.number,
    price: PropTypes.string,
    bid: PropTypes.object,
    renter: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
    currentUserKey: PropTypes.string,
  };

  componentWillMount() {
    this.getBillboardsData();
  }

  getBillboardsData = async () => {
    await actions.getBillboards();
  };

  render() {
    const { title, infoToggle } = this.props;
    return (
      <div className="contentWr">
        <Layout className="lyaoutWr">
          <Content>
            {" "}
            <Header title={title} infoToggle={this.props.infoToggle} />
            <Billboards />
            <Road />
            {this.props.children}
          </Content>
          {infoToggle && <Panel {...this.props} />}
        </Layout>
      </div>
    );
  }
}

export default connect(mapStateToProps)(BasicLayout);



// WEBPACK FOOTER //
// ./src/layouts/basic-layout.js